module.exports = __webpack_public_path__ + "img/env-company-pic1.c48bc2f9.png";